<ng-container *transloco="let t">
  <div class="wrapper-forms">
    <form [formGroup]="form">
      <mat-card appearance="outlined" [formGroupName]="'previousHistory'">
        <mat-card-content
          ><div class="justify-content-space-between">
            <div>
              <h5>{{ t('Previous history') }}</h5>
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
              "
            >
              <div class="column">
                <span> {{ t('Sterilization / castration') }}</span>
                <span>{{ t('Allergies') }}</span>
                <span>{{ t('Epilepsy') }}</span>
                <span>{{ t('A friend of a chronic illness/condition') }}</span>
              </div>
              <div style="width: 65%">
                <mat-form-field style="width: 100%" appearance="outline">
                  <textarea appAutofocus
                    matInput
                    rows="4"
                    [formControlName]="'previousHistoryNote'"
                  ></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row" style="align-items: center">
            <div style="width: 10%">
              <h5>{{ t('Anamnesis') }}</h5>
            </div>
            <div style="width: 90%">
              <mat-form-field style="width: 100%" appearance="outline">
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="'anamnesisNote'"
                ></textarea>
              </mat-form-field>
            </div></div
        ></mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" [formGroupName]="'trijas'">
        <mat-card-content>
          <div class="row" style="align-items: center; gap: 8px">
            <div style="width: 10%">
              <h5>{{ t('Trijas') }}</h5>
            </div>
            <div style="width: 90%" class="flex gap-xs">
              <mat-form-field appearance="outline">
                <mat-label>{{ t('Temperature') }}</mat-label>
                <input
                  matInput
                  formControlName="temperature"
                  type="number"
                  min="0"
                />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ t('Pulse') }}</mat-label>
                <input matInput formControlName="pulse" type="number" min="0" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ t('Breathing frequency') }}</mat-label>
                <input
                  matInput
                  formControlName="breathingFrequency"
                  type="number"
                  min="0"
                />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ t('Capillary refill (s)') }}</mat-label>
                <input
                  matInput
                  formControlName="capillaryRefill"
                  type="number"
                  min="0"
                />
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" [formGroupName]="'overallImpression'">
        <mat-card-content
          ><div class="row" style="align-items: center; gap: 8px">
            <div style="width: 10%">
              <h5>{{ t('Overall impression') }}</h5>
            </div>
            <div
              style="width: 90%"
              class="flex gap-xs justify-content-space-between"
            >
              <div class="column">
                <mat-checkbox formControlName="normal">{{
                  t('Normal')
                }}</mat-checkbox>
                <mat-checkbox formControlName="abnormal">{{
                  t('Abnormal')
                }}</mat-checkbox>
              </div>
              <div>
                <mat-form-field appearance="outline">
                  <mat-label>{{ t('TM (kg)') }}</mat-label>
                  <input matInput formControlName="tm" type="number" min="0" />
                </mat-form-field>
              </div>
              <div class="column">
                <mat-checkbox formControlName="skinny">{{
                  t('Skinny')
                }}</mat-checkbox>
                <mat-checkbox formControlName="normallyFed">{{
                  t('Normally fed')
                }}</mat-checkbox>
                <mat-checkbox formControlName="obese">{{
                  t('Obese')
                }}</mat-checkbox>
              </div>
              <mat-form-field appearance="outline" style="width: 30%">
                <mat-label>{{ t('Description of abnormality') }}</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="'descriptionAbnormality'"
                ></textarea>
              </mat-form-field>
            </div></div
        ></mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" [formGroupName]="'skin'">
        <mat-card-content
          ><div class="row" style="align-items: center; gap: 8px">
            <div style="width: 10%">
              <h5>{{ t('Skin') }}</h5>
            </div>
            <div
              style="width: 90%"
              class="flex gap-xs justify-content-space-between"
            >
              <div class="column">
                <mat-checkbox formControlName="normal">{{
                  t('Normal')
                }}</mat-checkbox>
                <mat-checkbox formControlName="abnormal">{{
                  t('Abnormal')
                }}</mat-checkbox>
              </div>
              <div class="flex gap-xs">
                <div class="rotated-container">
                  <h5 class="rotated-text">{{ t('TURGOR') }}</h5>
                </div>

                <div class="column">
                  <mat-checkbox formControlName="reduced">{{
                    t('Reduced')
                  }}</mat-checkbox>
                  <mat-checkbox formControlName="turgorNormal">{{
                    t('Normal')
                  }}</mat-checkbox>
                  <mat-checkbox formControlName="myxedema">{{
                    t('Myxedema')
                  }}</mat-checkbox>
                </div>
              </div>

              <div class="column">
                <mat-checkbox formControlName="conditionCoat">{{
                  t('Condition of the coat')
                }}</mat-checkbox>
                <mat-checkbox formControlName="paranalSacs">{{
                  t('Paranal sacs')
                }}</mat-checkbox>
                <mat-checkbox formControlName="anocutaneousTransition">{{
                  t('Anocutaneous transition')
                }}</mat-checkbox>
                <mat-checkbox formControlName="nailsInterdigital">{{
                  t('Nails and interdigital reg.')
                }}</mat-checkbox>
              </div>

              <div class="column">
                <mat-checkbox formControlName="ectoparasites">{{
                  t('Ectoparasites')
                }}</mat-checkbox>
                <mat-checkbox formControlName="tumors">{{
                  t('Tumors')
                }}</mat-checkbox>
                <mat-checkbox formControlName="skinLesions">{{
                  t('Skin lesions')
                }}</mat-checkbox>
              </div>

              <mat-form-field appearance="outline" style="width: 30%">
                <mat-label>{{ t('Description of abnormality') }}</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="'descriptionAbnormality'"
                ></textarea>
              </mat-form-field>
            </div></div
        ></mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" [formGroupName]="'mucousMembranes'">
        <mat-card-content
          ><div class="row" style="align-items: center; gap: 8px">
            <div style="width: 10%">
              <h5>{{ t('Mucous membranes') }}</h5>
            </div>
            <div
              style="width: 90%"
              class="flex gap-xs justify-content-space-between"
            >
              <div class="column">
                <mat-checkbox formControlName="normal">{{
                  t('Normal')
                }}</mat-checkbox>
                <mat-checkbox formControlName="abnormal">{{
                  t('Abnormal')
                }}</mat-checkbox>
              </div>

              <div class="column">
                <span>{{ t('Oral') }}</span>
                <span>{{ t('Conjunctival') }}</span>
                <span>{{ t('Genital') }}</span>
              </div>

              <div class="column">
                <mat-checkbox formControlName="pink">{{
                  t('mucousMembranes.Pink')
                }}</mat-checkbox>
                <mat-checkbox formControlName="pale">{{
                  t('Pale')
                }}</mat-checkbox>
                <mat-checkbox formControlName="cyanotic">{{
                  t('Cyanotic')
                }}</mat-checkbox>
              </div>

              <div class="column">
                <mat-checkbox formControlName="icteric">{{
                  t('Icteric')
                }}</mat-checkbox>
                <mat-checkbox formControlName="hyperemic">{{
                  t('Hyperemic')
                }}</mat-checkbox>
                <mat-checkbox formControlName="petechiae">{{
                  t('Petechiae')
                }}</mat-checkbox>
              </div>

              <div class="column">
                <mat-checkbox formControlName="erosions">{{
                  t('Erosions')
                }}</mat-checkbox>
              </div>

              <mat-form-field appearance="outline" style="width: 30%">
                <mat-label>{{ t('Description of abnormality') }}</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="'descriptionAbnormality'"
                ></textarea>
              </mat-form-field>
            </div></div
        ></mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" [formGroupName]="'lymphNodes'">
        <mat-card-content
          ><div class="row" style="align-items: center; gap: 8px">
            <div style="width: 10%">
              <h5>{{ t('Lymph nodes') }}</h5>
            </div>
            <div
              style="width: 90%"
              class="flex gap-xs justify-content-space-between"
            >
              <div class="column">
                <mat-checkbox formControlName="normal">{{
                  t('Normal')
                }}</mat-checkbox>
                <mat-checkbox formControlName="abnormal">{{
                  t('Abnormal')
                }}</mat-checkbox>
              </div>

              <div class="column">
                <span>{{ t('Submandibular') }}</span>
                <span>{{ t('Cervical') }}</span>
              </div>

              <div class="column">
                <span>{{ t('Axillary') }}</span>
                <span>{{ t('Inguinal') }}</span>
              </div>

              <div class="column">
                <span>{{ t('Popliteal') }}</span>
                <span>{{ t('Mesenteric') }}</span>
              </div>

              <mat-form-field appearance="outline" style="width: 30%">
                <mat-label>{{ t('Description of abnormality') }}</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="'descriptionAbnormality'"
                ></textarea>
              </mat-form-field>
            </div></div
        ></mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" [formGroupName]="'heartCirculation'">
        <mat-card-content
          ><div class="row" style="align-items: center; gap: 8px">
            <div style="width: 10%">
              <h5>{{ t('Heart and circulation') }}</h5>
            </div>
            <div
              style="width: 90%"
              class="flex gap-xs justify-content-space-between"
            >
              <div class="column">
                <mat-checkbox formControlName="normal">{{
                  t('Normal')
                }}</mat-checkbox>
                <mat-checkbox formControlName="abnormal">{{
                  t('Abnormal')
                }}</mat-checkbox>
              </div>

              <div class="column">
                <span>{{ t('Pulse quality') }}</span>
                <span>{{ t('Heart murmur') }}</span>
              </div>

              <div class="column">
                <span>{{ t('Arrhythmia') }}</span>
                <span>{{ t('Ictus cordis') }}</span>
              </div>

              <div class="column">
                <span>{{ t('Venous pulse') }}</span>
                <span>{{ t('Capillary filling') }}</span>
              </div>

              <mat-form-field appearance="outline" style="width: 30%">
                <mat-label>{{ t('Description of abnormality') }}</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="'descriptionAbnormality'"
                ></textarea>
              </mat-form-field>
            </div></div
        ></mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" [formGroupName]="'respiratoryTract'">
        <mat-card-content
          ><div class="row" style="align-items: center; gap: 8px">
            <div style="width: 10%">
              <h5>{{ t('Respiratory tract') }}</h5>
            </div>
            <div
              style="width: 90%"
              class="flex gap-xs justify-content-space-between"
            >
              <div class="column">
                <mat-checkbox formControlName="normal">{{
                  t('Normal')
                }}</mat-checkbox>
                <mat-checkbox formControlName="abnormal">{{
                  t('Abnormal')
                }}</mat-checkbox>
              </div>

              <div class="column">
                <h5>{{ t('Dyspnea') }}</h5>
                <mat-checkbox formControlName="inspirational">{{
                  t('Inspirational')
                }}</mat-checkbox>
                <mat-checkbox formControlName="expiratory">{{
                  t('Expiratory')
                }}</mat-checkbox>
                <mat-checkbox formControlName="mixed">{{
                  t('Mixed')
                }}</mat-checkbox>
              </div>

              <div class="column">
                <span>{{ t('Nasal discharge') }}</span>
                <span>{{ t('Farings') }}</span>
              </div>

              <div class="column">
                <h5>{{ t('Auscultation') }}</h5>
                <span>{{ t('Lungs') }}</span>
                <span>{{ t('Trachea') }}</span>
                <span>{{ t('Larings') }}</span>
                <span>{{ t('A cough') }}</span>
              </div>

              <div class="column">
                <h5>{{ t('Palpation:') }}</h5>
                <span>{{ t('Trachea') }}</span>
                <h5>{{ t('Percussion:') }}</h5>
                <span>{{ t('Chest') }}</span>
              </div>

              <mat-form-field appearance="outline" style="width: 30%">
                <mat-label>{{ t('Description of abnormality') }}</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="'descriptionAbnormality'"
                ></textarea>
              </mat-form-field>
            </div></div
        ></mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" [formGroupName]="'digestiveTractAbdomen'">
        <mat-card-content
          ><div class="row" style="align-items: center; gap: 8px">
            <div style="width: 10%">
              <h5>{{ t('Digestive tract and abdomen') }}</h5>
            </div>
            <div
              style="width: 90%"
              class="flex gap-xs justify-content-space-between"
            >
              <div class="column">
                <mat-checkbox formControlName="normal">{{
                  t('Normal')
                }}</mat-checkbox>
                <mat-checkbox formControlName="abnormal">{{
                  t('Abnormal')
                }}</mat-checkbox>
              </div>

              <div class="column">
                <span>{{ t('Appetite') }}</span>
                <span>{{ t('Vomiting') }}</span>
                <span>{{ t('Diarrhea') }}</span>
                <span>{{ t('Hypersalvation') }}</span>
                <span>{{ t('Haltose') }}</span>
                <span>{{ t('Teeth') }}</span>
                <span>{{ t('Tonsils') }}</span>
                <span>{{ t('Salivary glands') }}</span>
              </div>

              <div class="column">
                <div class="column">
                  <h5>{{ t('A chair:') }}</h5>
                  <span>{{ t('Frequency') }}</span>
                  <span>{{ t('Consistency') }}</span>
                  <span>{{ t('The color') }}</span>
                </div>
                <div>
                  <h5>{{ t('Rectal examination') }}</h5>
                </div>
              </div>

              <div class="column">
                <div class="column">
                  <h5>{{ t('Abdominal palpation') }}</h5>
                  <span>{{ t('Wall tension') }}</span>
                  <span>{{ t('Palpable masses') }}</span>
                  <span>{{ t('Soreness') }}</span>
                </div>
                <div>
                  <h5>{{ t('Abdominal percussion') }}</h5>
                </div>
              </div>

              <mat-form-field appearance="outline" style="width: 30%">
                <mat-label>{{ t('Description of abnormality') }}</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="'descriptionAbnormality'"
                ></textarea>
              </mat-form-field>
            </div></div
        ></mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" [formGroupName]="'urogenitalTract'">
        <mat-card-content>
          <div class="column">
            <div class="row" style="align-items: center; gap: 8px">
              <div style="width: 10%">
                <h5>{{ t('Urogenital tract') }}</h5>
              </div>
              <div
                style="width: 90%"
                class="flex gap-xs justify-content-space-between"
              >
                <div class="column">
                  <h5>{{ t('Water consumption') }}</h5>
                  <mat-checkbox formControlName="waterConsumptionReduced">{{
                    t('Reduced')
                  }}</mat-checkbox>
                  <mat-checkbox formControlName="waterConsumptionNormal">{{
                    t('Normal')
                  }}</mat-checkbox>
                  <mat-checkbox formControlName="waterConsumptionIncreased">{{
                    t('Increased')
                  }}</mat-checkbox>
                </div>

                <div class="column">
                  <h5>{{ t('Urine production') }}</h5>
                  <mat-checkbox formControlName="urineProductionReduced">{{
                    t('Reduced')
                  }}</mat-checkbox>
                  <mat-checkbox formControlName="urineProductionNormal">{{
                    t('Normal')
                  }}</mat-checkbox>
                  <mat-checkbox formControlName="urineProductionIncreased">{{
                    t('Increased')
                  }}</mat-checkbox>
                </div>

                <div class="column">
                  <h5>{{ t('Palpation:') }}</h5>
                  <span>{{ t('Bladder') }}</span>
                  <span>{{ t('Kidneys') }}</span>
                  <span>{{ t('Prostate') }}</span>
                  <span>{{ t('Testicles') }}</span>
                  <span>{{ t('Penis') }}</span>
                  <span>{{ t('Foreskin') }}</span>
                  <span>{{ t('Mammary complexes') }}</span>
                </div>

                <div class="column">
                  <span>{{ t('History of estrus and pregnancy') }}</span>
                </div>

                <mat-form-field appearance="outline" style="width: 30%">
                  <mat-label>{{ t('Description of abnormality') }}</mat-label>
                  <textarea
                    matInput
                    rows="4"
                    [formControlName]="'descriptionAbnormality'"
                  ></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="flex" style="width: 100%; margin-top: 16px">
              <div style="width: 10%"></div>
              <div style="width: 90%">
                <mat-chip-set aria-label="Fish selection">
                  <mat-chip>{{ t('Dysuria') }}</mat-chip>
                  <mat-chip>{{ t('Stranguria') }}</mat-chip>
                  <mat-chip>{{ t('Discharge (vagina, foreskin)') }}</mat-chip>
                </mat-chip-set>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card
        appearance="outlined"
        [formGroupName]="'nervousLocomotorSystem'"
      >
        <mat-card-content
          ><div class="row" style="align-items: center; gap: 8px">
            <div style="width: 10%">
              <h5>{{ t('Nervous and locomotor system') }}</h5>
            </div>
            <div
              style="width: 90%"
              class="flex gap-xs justify-content-space-between"
            >
              <div class="column">
                <mat-checkbox formControlName="normal">{{
                  t('Normal')
                }}</mat-checkbox>
                <mat-checkbox formControlName="abnormal">{{
                  t('Abnormal')
                }}</mat-checkbox>
              </div>

              <div class="column">
                <span>{{ t('Mental status') }}</span>
                <span>{{ t('Attitude') }}</span>
                <span>{{ t('Movement coordination') }}</span>
                <span>{{ t('Tics') }}</span>
                <span>{{ t('History of head trauma') }}</span>
                <!-- OVO PROVERI  pisalo je Istprija kao Istorija sam napisao -->
              </div>

              <div class="column">
                <span>{{ t('Nociosepsis') }}</span>
                <span>{{ t('Cranial reflexes') }}</span>
                <span>{{ t('Postural reactions') }}</span>
                <span>{{ t('Spinal reflexes') }}</span>
              </div>

              <div class="column">
                <h5>{{ t('Joints') }}</h5>
                <span>{{ t('Mobility') }}</span>
                <span>{{ t('Palpation') }}</span>
              </div>

              <mat-form-field appearance="outline" style="width: 30%">
                <mat-label>{{ t('Description of abnormality') }}</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="'descriptionAbnormality'"
                ></textarea>
              </mat-form-field>
            </div></div
        ></mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" [formGroupName]="'ears'">
        <mat-card-content
          ><div class="row" style="align-items: center; gap: 8px">
            <div style="width: 10%">
              <h5>{{ t('Ears') }}</h5>
            </div>
            <div
              style="width: 90%"
              class="flex gap-xs justify-content-space-between"
            >
              <div class="column">
                <mat-checkbox formControlName="normal">{{
                  t('Normal')
                }}</mat-checkbox>
                <mat-checkbox formControlName="abnormal">{{
                  t('Abnormal')
                }}</mat-checkbox>
              </div>

              <div class="column">
                <h5>{{ t('Earlobe') }}</h5>
                <h5>{{ t('Ear canal') + ':' }}</h5>
                <span>{{ t('Appearance of cerumen') }}</span>
                <span>{{ t('Foreign bodies, warts') }}</span>
                <span>{{ t('Eardrum') }}</span>
              </div>

              <mat-form-field appearance="outline" style="width: 30%">
                <mat-label>{{ t('Description of abnormality') }}</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="'descriptionAbnormality'"
                ></textarea>
              </mat-form-field>
            </div></div
        ></mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" [formGroupName]="'eyes'">
        <mat-card-content
          ><div class="row" style="align-items: center; gap: 8px">
            <div style="width: 10%">
              <h5>{{ t('Eyes') }}</h5>
            </div>
            <div
              style="width: 90%"
              class="flex gap-xs justify-content-space-between"
            >
              <div class="column">
                <mat-checkbox formControlName="normal">{{
                  t('Normal')
                }}</mat-checkbox>
                <mat-checkbox formControlName="abnormal">{{
                  t('Abnormal')
                }}</mat-checkbox>
              </div>

              <div class="column">
                <h5>{{ t('Eye lids') }}</h5>
                <h5>{{ t('Discharge from the eyes') }}</h5>
              </div>

              <div class="column">
                <h5>{{ t('Conjunctiva and sclera:') }}</h5>
                <span>{{ t('The color') }}</span>
                <span>{{ t('Petechiae') }}</span>
                <span>{{ t('Initiation of blood vessels') }}</span>
              </div>

              <div class="column">
                <h5>{{ t('Cornea:') }}</h5>
                <span>{{ t('Erosions') }}</span>
                <span>{{ t('Ulcerations') }}</span>
                <span>{{ t('Stains') }}</span>
                <span>{{ t('Lens transparency') }}</span>
              </div>

              <mat-form-field appearance="outline" style="width: 30%">
                <mat-label>{{ t('Description of abnormality') }}</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="'descriptionAbnormality'"
                ></textarea>
              </mat-form-field>
            </div></div
        ></mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" [formGroupName]="'recommendedAnalysis'">
        <mat-card-content
          ><div class="row" style="align-items: center; gap: 8px">
            <div style="width: 10%">
              <h5>{{ t('RECOMMENDED ANALYSIS') }}</h5>
            </div>
            <div
              style="width: 90%"
              class="flex gap-xs justify-content-space-between"
            >
              <div class="column">
                <mat-checkbox formControlName="hematology">{{
                  t('Hematology')
                }}</mat-checkbox>
                <mat-checkbox formControlName="biochemistry">{{
                  t('Biochemistry')
                }}</mat-checkbox>
                <mat-checkbox formControlName="xRay">{{
                  t('RTG')
                }}</mat-checkbox>
              </div>

              <div class="column">
                <mat-checkbox formControlName="ekg">{{
                  t('EKG')
                }}</mat-checkbox>
                <mat-checkbox formControlName="echo">{{
                  t('ECHO')
                }}</mat-checkbox>
                <mat-checkbox formControlName="mriCt">{{
                  t('MRI/CT')
                }}</mat-checkbox>
              </div>

              <div class="column">
                <mat-checkbox formControlName="biopsy">{{
                  t('Biopsy')
                }}</mat-checkbox>
                <mat-checkbox formControlName="endoscopy">{{
                  t('Endoscopy')
                }}</mat-checkbox>
                <mat-checkbox formControlName="urineAnalysis">{{
                  t('Urine analysis')
                }}</mat-checkbox>
              </div>

              <mat-form-field appearance="outline" style="width: 30%">
                <mat-label>{{ t('Other') }}</mat-label>
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="'other'"
                ></textarea>
              </mat-form-field>
            </div></div
        ></mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" [formGroupName]="'listProblems'">
        <mat-card-content>
          <div class="row" style="align-items: center; gap: 8px">
            <div style="width: 10%">
              <h5>{{ t('List of problems') }}</h5>
            </div>
            <div
              style="width: 90%"
              class="flex gap-xs justify-content-space-between"
            >
              <div class="column gap-xs">
                <mat-form-field style="width: 100%" appearance="outline">
                  <input matInput [formControlName]="'problem1'" />
                </mat-form-field>
                <mat-form-field style="width: 100%" appearance="outline">
                  <input matInput [formControlName]="'problem2'" />
                </mat-form-field>
                <mat-form-field style="width: 100%" appearance="outline">
                  <input matInput [formControlName]="'problem3'" />
                </mat-form-field>
              </div>

              <div class="column gap-xs">
                <mat-form-field style="width: 100%" appearance="outline">
                  <input matInput [formControlName]="'problem4'" />
                </mat-form-field>
                <mat-form-field style="width: 100%" appearance="outline">
                  <input matInput [formControlName]="'problem5'" />
                </mat-form-field>
                <mat-form-field style="width: 100%" appearance="outline">
                  <input matInput [formControlName]="'problem6'" />
                </mat-form-field>
              </div>

              <div class="column gap-xs">
                <mat-form-field style="width: 100%" appearance="outline">
                  <input matInput [formControlName]="'problem7'" />
                </mat-form-field>
                <mat-form-field style="width: 100%" appearance="outline">
                  <input matInput [formControlName]="'problem8'" />
                </mat-form-field>
                <mat-form-field style="width: 100%" appearance="outline">
                  <input matInput [formControlName]="'problem9'" />
                </mat-form-field>
              </div>
            </div></div
        ></mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" [formGroupName]="'therapy'">
        <mat-card-content
          ><div class="column" style="align-items: center; gap: 8px">
            <div style="width: 100%" class="gap-xs">
              <h5 style="width: 10%">
                {{ t('Diagnosis / working diagnosis') }}
              </h5>
              <mat-form-field appearance="outline" style="width: 90%">
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="'workingDiagnosis'"
                ></textarea>
              </mat-form-field>
            </div>

            <div style="width: 100%" class="gap-xs">
              <h5 style="width: 10%">{{ t('Therapy') }}</h5>
              <mat-form-field appearance="outline" style="width: 90%">
                <textarea
                  matInput
                  rows="4"
                  [formControlName]="'therapy'"
                ></textarea>
              </mat-form-field>
            </div>

            <div style="width: 100%" class="gap-xs">
              <h5 style="width: 10%">{{ t('veterinarianName') }}</h5>
              <mat-form-field appearance="outline" style="width: 90%">
                <input matInput [formControlName]="'veterinarianName'" />
                <mat-error>{{ t('This field is required') }}</mat-error>
              </mat-form-field>
            </div></div
        ></mat-card-content>
      </mat-card>
    </form>
  </div>
</ng-container>
